import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { ConfigureConnectionComponent } from './components/configure-connection/configure-connection.component';

const routes: Routes = [{ path: '', component: ConfigureConnectionComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class DataConnectionRoutingModule {}
